import type { Client } from '@fitness-force/models';

/** Mirrors API bucket shape for tenant omnisearch (avoid importing @fitness-force/shared). */
export interface MiniSearchV2TenantBucket {
  total_items: number;
  items: Client[];
}

export interface MiniSearchV2TenantLevel {
  prospects_and_trials: MiniSearchV2TenantBucket;
  active_clients_and_non_members: MiniSearchV2TenantBucket;
  ex_clients_and_non_members: MiniSearchV2TenantBucket;
  blocked_clients: MiniSearchV2TenantBucket;
}

export interface MiniSearchV2TenantSearchResults {
  total_items: number;
  tenant_level_clients: MiniSearchV2TenantLevel[];
}

/** Provider path segment for POST search by provider — must match OmniSearchProvider string names. */
export const MINI_SEARCH_V2_PROVIDERS = {
  PROSPECT: 'ProspectsAndTrials',
  ACTIVE: 'ActiveClientsAndNonMembers',
  EX_CLIENT: 'ExClientsAndNonMembers',
  BLOCKED: 'BlockedClients',
} as const;

export type MiniSearchV2StatLabel =
  | 'PROSPECT'
  | 'ACTIVE'
  | 'EX_CLIENT'
  | 'BLOCKED';

export interface MiniSearchV2StatSegment {
  label: MiniSearchV2StatLabel;
  provider: string;
  total: number;
  items: Client[];
  /** True after “show all” fetch merged every item for this bucket. */
  fullyLoaded: boolean;
}
